<h2>How to Play Tele-Sketchpad:</h2>
<p>This simple and fun game tests your drawing skills and combines them with the old school yard telephone game, you know the one where a phrase gets passed from person to person until the message totally gets changed!</p>

<p>In this game you will receive an initial word or phrase and you draw it.</p>
<p>The next round, you will receive another person's drawing and guess what they drew.</p>
<p>You keep passing the drawings and guesses around until everyone has guessed or drew on the original phrase.</p>
<p>At the end, this host screen will display everyone's drawings and guesses and you can then see what hilarious guesses your friends came up with!</p>
